import { toast } from "components/ui/use-toast";

const MIME_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const downloadExcel = (
  excelFile: string,
  fileName: string
) => {
  if (!excelFile || !excelFile.startsWith(`data:${MIME_TYPE};base64,`)) {
    toast({
      description: "Nenhum arquivo disponível para download.",
      variant: "destructive",
    });
    return;
  }

  try {
    const base64Data = excelFile.split(",")[1];
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length)
      .fill(0)
      .map((_, i) => byteCharacters.charCodeAt(i));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: MIME_TYPE });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast({
      description: "Download iniciado com sucesso!",
      variant: "success",
    });
  } catch (error) {
    toast({
      description: "Erro ao processar o arquivo.",
      variant: "destructive",
    });
    console.error("Erro ao converter Base64 para Excel:", error);
  }
};

export const downloadExcelBlob = (blob: Blob, fileName: string) => {
  try {
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    toast({
      description: "Download iniciado com sucesso!",
      variant: "success",
    });
  } catch (error) {
    toast({
      description: "Erro ao processar o arquivo.",
      variant: "destructive",
    });
    console.error("Erro ao fazer download do Excel:", error);
  }
};
